import React from 'react';
import {Button, Modal} from "react-bootstrap";
import ExpertReportContent from "../../ProjectReportTabs/ExpertReportContent";
import CloseProjContent from "../../ProjectReportTabs/CloseProjContent";
import DraggableModal from '../DraggableModal';

const ModalCloseProj = ({show,onClose,onConfirm,onCloseDataChange,closeData}) => {

    const handleChangeFiles = (newFiles) => {
        onCloseDataChange('closeFiles',newFiles);
    };

    const handleCloseDateChange = ({ target }) => {
        onCloseDataChange('closedOn',target.value);
    };
    return (
        <DraggableModal show={show} size="lg" headerNode='Закрытие проекта' onHide={onClose}>

            <Modal.Body>
                <CloseProjContent closeData={closeData}  callbacks={{handleChangeFiles,handleCloseDateChange}}/>
            </Modal.Body>


            <Modal.Footer>
                <Button
                    onClick={onClose}
                    variant="outline-secondary"
                >
                    Отмена
                </Button>
                <Button
                    onClick={onConfirm}
                    variant={'danger'}
                >
                    Закрыть проект
                </Button>
            </Modal.Footer>
        </DraggableModal>
    );
};

export default ModalCloseProj;
